const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  AVAILABLE: {
    id: 'Pricing.Details.Available',
    defaultMessage: 'available',
    desc: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
  },
  UNAVAILABLE: {
    id: 'Pricing.Details.Unavailable',
    defaultMessage: 'unavailable',
    desc: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
  },
});

export default COPY;
